"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_STATUS_TYPES = void 0;
var ICON_STATUS_TYPES = Object.freeze({
  info: 'info',
  success: 'success'
});
exports.ICON_STATUS_TYPES = ICON_STATUS_TYPES;